import { useTranslation } from 'react-i18next';
import { Button } from '@treezor/design-system';

import { useUserCardOverview } from '../../hooks/useUserCardOverview';

import { IPaymentCard } from '@/features/cards/store/models/card.model';

import { CardItem } from './CardItem';

interface ICardOverviewProps {
  cards: IPaymentCard[];
}

export function UserCardOverview({ cards }: ICardOverviewProps) {
  const { t } = useTranslation();

  const { hasAllCards, displayedCards, handleNavigate, totalRows } = useUserCardOverview(cards);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-5">
        {displayedCards.map((card) => (
          <CardItem key={`card-overview-item-${card.cardId}`} card={card} handleNavigate={handleNavigate} />
        ))}
        {!hasAllCards && (
          <div className="flex items-center justify-end">
            <Button variant="ghost" size="s" icon="chevron_right" iconPosition="right" onClick={() => handleNavigate()}>
              {t('pages.currentProfiles.profile.overview.allCards', { value: totalRows })}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
